import { Badge, Button, ButtonGroup } from '@chakra-ui/react';

export const SegmentedControls = <T extends string | boolean | undefined>({
    options,
    selectedValue,
    onClick,
    size = 'sm',
    variant = 'outline',
    stretch,
}: {
    options: { value: T; label: string; disabled?: boolean; badge?: number }[];
    selectedValue?: T;
    onClick: (value: T) => void;
    size?: 'sm' | 'xs';
    variant?: 'outline' | 'solid';
    stretch?: boolean;
}) => {
    return (
        <ButtonGroup size={size} isAttached variant={variant} width={stretch ? '100%' : 'auto'}>
            {options.map(({ value, label, disabled, badge }) => (
                <Button
                    key={String(value)}
                    flex={stretch ? 1 : undefined}
                    onClick={() => onClick(value)}
                    colorScheme={selectedValue === value ? 'teal' : 'gray'}
                    isDisabled={disabled}
                    gap={badge !== undefined ? 1.5 : undefined}
                >
                    {label}
                    {badge !== undefined && (
                        <Badge
                            colorScheme={selectedValue === value ? 'teal' : 'gray'}
                            borderRadius="full"
                            fontSize="10px"
                            lineHeight="1.5"
                        >
                            {badge}
                        </Badge>
                    )}
                </Button>
            ))}
        </ButtonGroup>
    );
};
